type ImageWithCaption = {
    src: string;
    caption: string;
}

export const HOME_IMAGES: ImageWithCaption[] = [
    {
        src: './images/birds.jpg',
        caption: 'Santa Cruz, 2022'
    },
    {
        src: './images/women_march.jpg',
        caption: "Women's March, Civic Center, 2022",
    },
    {
        src: './images/vegas_double_exposure.jpg',
        caption: "Double Exposure, Las Vegas, 2024",
    },
    {
        src: './images/foster_city.jpg',
        caption: 'A Couple, Fostery City, 2022'
    },
    {
        src: './images/golden_gate_bird.jpg',
        caption: 'Golden Gate Bridge, 2022'
    },
    {
        src: './images/pride.jpg',
        caption: 'Pride Parade, San Francisco, 2021'
    },
    {
        src: './images/santa_cruz_boat.jpg',
        caption: 'Santa Cruz, 2022'
    },
];